import type { MeDto, ThemeDto } from "@/lib/types";
import { ThemeProvider } from "./theme-provider";
import { SessionProvider } from "./session-provider";
import { WorkspaceProvider } from "./workspace-provider";
import { NotificationsProvider } from "./notifications-provider";
import { RegistrationsProvider } from "./registrations-provider";
import { SidebarProvider } from "./sidebar-provider";
import { InstallProvider } from "./install-provider";
import { AdminDashboardProvider } from "./admin-dashboard-provider";
import { ToastProvider } from "@/components/ui/toast";
import { AppShell } from "@/components/layout/app-shell";
import { InstallPrompt, InstallHelpDialog } from "@/components/install-prompt";
import type { ReactNode } from "react";

export function AppProviders({
  brand,
  initialMe,
  children,
}: {
  brand: ThemeDto;
  initialMe: MeDto | null;
  children: ReactNode;
}) {
  return (
    <ThemeProvider brand={brand}>
      <SessionProvider initialMe={initialMe}>
        <WorkspaceProvider>
          <AdminDashboardProvider>
            <NotificationsProvider>
              <RegistrationsProvider>
                <SidebarProvider>
                  <InstallProvider>
                    <ToastProvider>
                  <a
                    href="#main"
                    className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[200] focus:rounded-lg focus:bg-[var(--brand-accent)] focus:px-4 focus:py-2 focus:font-semibold focus:text-white"
                  >
                    Skip to content
                  </a>
                  <AppShell>{children}</AppShell>
                  <InstallPrompt />
                  <InstallHelpDialog />
                    </ToastProvider>
                  </InstallProvider>
                </SidebarProvider>
              </RegistrationsProvider>
            </NotificationsProvider>
          </AdminDashboardProvider>
        </WorkspaceProvider>
      </SessionProvider>
    </ThemeProvider>
  );
}
